import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-white py-4 border-t border-gray-200" data-id="element-376">
      <div className="container mx-auto px-4" data-id="element-377">
        <div className="flex justify-center" data-id="element-378">
          <Link to="/impressum" className="text-sm text-gray-600 hover:text-gray-800" data-id="element-379">
            Impressum
          </Link>
        </div>
      </div>
    </footer>;
}